import React from "react"

import teamPictureStyle from "../../styles/about/teampicture.module.scss"

const TeamPicture = () => (
  <div className={teamPictureStyle.teamPicture}>

  </div>
)

export default TeamPicture
